import * as Schema from "effect/Schema";
const Text = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(12000));
const WorkerId = Schema.Struct({ workerId: Text });
const RecordingId = Schema.Struct({ recordingId: Text });
export const WorkerToolInputs = {
  worker_create: Schema.Struct({
    key: Text,
    template: Schema.optionalKey(Text),
    ttlSeconds: Schema.optionalKey(
      Schema.Int.check(Schema.isBetween({ minimum: 60, maximum: 3600 })),
    ),
    variables: Schema.optionalKey(Schema.Array(Text).check(Schema.isMaxLength(32))),
  }),
  worker_list: Schema.Struct({}),
  worker_exec: Schema.Struct({
    ...WorkerId.fields,
    command: Text,
    cwd: Schema.optionalKey(Text),
    detached: Schema.optionalKey(Schema.Boolean),
    timeoutSeconds: Schema.optionalKey(
      Schema.Int.check(Schema.isBetween({ minimum: 1, maximum: 600 })),
    ),
  }),
  worker_process: Schema.Struct({
    ...WorkerId.fields,
    processId: Schema.Int.check(Schema.isGreaterThan(0)),
  }),
  worker_repository_prepare: Schema.Struct({
    ...WorkerId.fields,
    connectionId: Text,
    repositoryId: Text,
    branch: Schema.optionalKey(Text),
    commit: Schema.optionalKey(Schema.String.check(Schema.isPattern(/^[a-f0-9]{40,64}$/u))),
    setup: Schema.optionalKey(Schema.Array(Text).check(Schema.isMaxLength(16))),
  }),
  worker_browser: Schema.Struct({
    ...WorkerId.fields,
    tool: Schema.optionalKey(Text),
    arguments: Schema.optionalKey(Schema.Record(Schema.String, Schema.Unknown)),
  }),
  worker_stop: WorkerId,
  recording_start: Schema.Struct({
    ...WorkerId.fields,
    key: Text,
    maxSeconds: Schema.optionalKey(
      Schema.Int.check(Schema.isBetween({ minimum: 1, maximum: 300 })),
    ),
  }),
  recording_status: RecordingId,
  recording_stop: RecordingId,
  recording_discard: RecordingId,
  worker_artifact_import: Schema.Struct({
    ...WorkerId.fields,
    key: Text,
    name: Text,
    path: Schema.optionalKey(Text),
    recordingId: Schema.optionalKey(Text),
  }),
  artifact_storage_status: Schema.Struct({}),
  artifact_upload: Schema.Struct({ key: Text, name: Text, path: Text }),
  artifact_download: Schema.Struct({ id: Text }),
  artifact_delete: Schema.Struct({ id: Text }),
} as const;
export const WorkerRecord = Schema.Struct({
  id: Text,
  projectId: Text,
  conversationId: Text,
  principalId: Text,
  runId: Text,
  credential: Text,
  operationId: Text,
  ttlSeconds: Schema.Int,
  variables: Schema.Array(Text),
  template: Schema.optionalKey(Text),
  sandboxId: Schema.optionalKey(Text),
  allocationAttempted: Schema.optionalKey(Schema.Boolean),
  status: Schema.Literals(["creating", "ready", "cleanup", "stopped"]),
  createdAt: Text,
  repository: Schema.optionalKey(
    Schema.Struct({ connectionId: Text, repositoryId: Text, commit: Text }),
  ),
});
export const WorkerRecordingRecord = Schema.Struct({
  id: Text,
  workerId: Text,
  key: Text,
  runId: Text,
  path: Text,
  createdAt: Text,
  status: Schema.Literals(["recording", "stopped", "saved", "discarded"]),
  bytes: Schema.Int,
  artifactId: Schema.optionalKey(Text),
});
export type WorkerRecord = typeof WorkerRecord.Type;
export type WorkerRecordingRecord = typeof WorkerRecordingRecord.Type;
